import { render, staticRenderFns } from "./SwapConfirmation.vue?vue&type=template&id=d7f97cd0&"
import script from "./SwapConfirmation.vue?vue&type=script&lang=js&"
export * from "./SwapConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./SwapConfirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src781945140/src/BedBoard.Sdk.Receiver/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d7f97cd0', component.options)
    } else {
      api.reload('d7f97cd0', component.options)
    }
    module.hot.accept("./SwapConfirmation.vue?vue&type=template&id=d7f97cd0&", function () {
      api.rerender('d7f97cd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SwapConfirmation.vue"
export default component.exports